'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMostRecentOpenThread = undefined;

var _reselect = require('reselect');

var _getOpenThreads = require('./getOpenThreads');

var getMostRecentOpenThread = exports.getMostRecentOpenThread = (0, _reselect.createSelector)([_getOpenThreads.getOpenThreads], function (openThreads) {
  return openThreads ? openThreads.first() : undefined;
});


//////////////////
// WEBPACK FOOTER
// ./js/threads/selectors/getMostRecentOpenThread.js
// module id = 965
// module chunks = 2 3